import { combineReducers } from 'redux'
import app from './app'
import merchant from "./merchant";
import dashboard from './dashboard'
import orders from "./orders";
import settlements from './settlements'
import users from './users'
import developer from './developer'
import orderDetail from './orderDetail'
import account from "./account"
import createLink from "./createLink"
import searchLink from "./searchLink"
import exchangeApply from "./exchangeApply"
import exchangeRecords from "./exchangeRecords"

export default combineReducers({
    app,
    merchant,
    dashboard,
    orders,
    settlements,
    users,
    developer,
    orderDetail,
    account,
	createLink,
	searchLink,
	exchangeApply,
	exchangeRecords
})